import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarSquareRegularEventIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.8 3.2q1.1 0 1.2 1.2v2h8v-2a1.2 1.2 0 1 1 2.4 0v2H24c1.8 0 3.2 1.4 3.2 3.2V24c0 1.8-1.4 3.2-3.2 3.2H8A3 3 0 0 1 4.8 24V9.6c0-1.8 1.4-3.2 3.2-3.2h1.6v-2q0-1.1 1.2-1.2m0 5.6H8q-.7.1-.8.8V12h17.6V9.6q-.1-.7-.8-.8zm-3.6 5.6V24q.1.7.8.8h16q.7-.1.8-.8v-9.6z" })
});
export default SvgCalendarSquareRegularEventIcon;
